/**
 * @param {string} page
 * @param {{[key: string]: string[]}} actionsOnPage
 * @return {string[]} action name
 * @public
 */
export const getCurrentAnalyticsActions = (page, actionsOnPage) => {
    return Object.keys(actionsOnPage).filter((key) => {
        return actionsOnPage[key].includes(page);
    }) ?? '';
};
